var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-two"},[_c('div',{staticClass:"dragonfly",style:({ backgroundImage: 'url(' + _vm.dragonfly + ')' })}),_c('div',{staticClass:"page-content"},[_c('about-main'),_c('professional-experience'),_c('certifications'),_c('education'),_c('personal'),_c('resume')],1),_c('div',{staticStyle:{"height":"150px"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }